import Localization from "../../../../../localization";
import { Constants } from "../../../../../utils";
import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Flex } from "antd";
import {
  Checkbox,
  Copyable,
  Button,
  Modal,
  Card,
  Text,
  Form,
} from "../../../../../components";

const Phone = ({ onDone = async () => {} }) => {
  const [accepted, setAccepted] = useState(false);
  const numberModalRef = useRef();
  const form = useRef();

  const onConfirm = async () => {
    await form.current.validateFields();
    await onDone(
      form.current.getFieldsValue({
        format: { name: "phone", key: "phone" },
      }).phone
    );
    numberModalRef.current.close();
  };

  return (
    <Styled>
      <Text
        weight={"600"}
        color="secondary"
        children={Localization.service_edit_phone.title}
      />
      <Text
        color="secondary"
        className="m-10-t"
        children={Localization.service_edit_phone.desc_1}
      />
      <Card bordered className="m-25-t">
        <Text
          level={5}
          weight={"600"}
          color="secondary"
          className="m-10-b"
          children={Localization.general.safelands_phone_number + ":"}
        />
        <Flex align="center" justify="space-between">
          <Text
            level={2}
            weight={"700"}
            className="phone-number"
            children={Constants.Project.phones.support}
          />
          <Copyable level={3} children={Constants.Project.phones.support} />
        </Flex>
      </Card>
      <Checkbox
        className="m-15-t"
        checked={accepted}
        children={Localization.service_edit_phone.condition}
        onChange={(_) => setAccepted(_.target.checked)}
      />
      <Button
        type="primary"
        className="m-30-t"
        disabled={!accepted}
        title={Localization.general.continue}
        onClick={() => numberModalRef.current.open()}
      />
      <Modal
        ref={numberModalRef}
        title={Localization.general.connect_alarm}
        child={() => (
          <div>
            <Text
              weight={"600"}
              color="secondary"
              children={Localization.service_edit_phone.number_modal_title}
            />
            <Text
              color="secondary"
              className="m-5-t"
              children={Localization.service_edit_phone.number_modal_desc}
            />
            <Form
              ref={form}
              className="m-15-t m-25-b"
              fields={[
                {
                  name: "phone",
                  rules: [{ type: "phone", required: true }],
                  label: Localization.general.phone_number,
                  placeholder: Localization.general.phone_number,
                },
              ]}
            />
            <Form.Submit
              type="primary"
              onClick={() => onConfirm()}
              title={Localization.general.confirm}
            />
          </div>
        )}
      />
    </Styled>
  );
};

const Styled = styled.div`
  .phone-number {
    ${(_) => _.theme.mobile(`font-size: 2.4rem;`)}
  }
`;

export default Phone;
